import React from "react";
import AsyncSelect from "../../AsyncSelect/AsyncSelect";
import { useAppContext } from "../../../../AppProvider";

export const AsyncSelectFilter = ({
  filter,
  value,
  onChange,
  isDisabled,
  searchKey,
}) => {
  const { dictionary } = useAppContext();

  return (
    <AsyncSelect
      name={filter.fieldName}
      optionStyle={filter.optionStyle}
      onSearch={(fieldName, options) => {
        if (options) {
          options = Array.isArray(options) ? options : [options];
        } else {
          options = [];
        }
        onChange(fieldName, options);
      }}
      loadOptions={filter.loadOptions}
      isMulti={filter.isMulti}
      value={value}
      placeholder={dictionary.actions.select}
      closeMenuOnSelect={!filter.isMulti}
      isDisabled={isDisabled}
      searchKey={searchKey}
    />
  );
};
